import React from 'react'
import  Navbar  from '../Navbar'
import Sidebar from '../Sidebar' 

function Webcatta() {
  return <>
  <Navbar/>
  <Sidebar/>
  </>
}

export default Webcatta
